export default __webpack_public_path__ + "static/media/zero leakage.13c1b363.png";